export default __webpack_public_path__ + "static/media/logo__technology__aws.03e5ca21.png";